import { render, staticRenderFns } from "./RecRisk.vue?vue&type=template&id=e24b023e&scoped=true"
import script from "./RecRisk.vue?vue&type=script&lang=js"
export * from "./RecRisk.vue?vue&type=script&lang=js"
import style0 from "./RecRisk.vue?vue&type=style&index=0&id=e24b023e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24b023e",
  null
  
)

export default component.exports